import { AppRoutes } from '@consts/routes';
import { useTicketSubmissionMutation , useTicketPrefillQuery } from '@features/redux/apis/tickets';
import { MutationEffect } from '@helpers/MutationEffect';
import { useAlert } from '@hooks/useAlert';
import { useNavigate } from 'react-router-dom';

import { QueryEffect } from '@helpers/QueryEffect';
import { useQuery } from '@hooks/useQuery';
import { useEffect } from 'react';

interface PrefillParams {
  draft: [Record<string, any>, React.Dispatch<React.SetStateAction<Record<string, any>>>]
}

export const TicketEffects = (params: PrefillParams) => {
    const queryStrings = useQuery();
    const serialNum = queryStrings.get('serialNum') || '';

    const { setAlert } = useAlert();
    const navigate = useNavigate();

    const queryState = useTicketPrefillQuery({ serialNum });
    const [, mutationState] = useTicketSubmissionMutation({
        fixedCacheKey: 'SubmitTicketMutation',
    });

    const [draftState, setDraftState] = params.draft;
    const persistedState = localStorage.getItem('MO_TICKETS');


    useEffect(() => {
      /** Hydrate persisted state if available */
      if(persistedState){
        const { expires, ...rest } = JSON.parse(persistedState);
        setDraftState({...draftState, ...rest });
      }
      /** State  */
    }, [persistedState]);



    return (
        <>
            <QueryEffect
                queryState={queryState}
                effects={{
                  isError: () => {
                    setDraftState({
                      ...draftState,
                      companyName: '',
                      locationName: ''
                    });},
                  isSuccess: () => {
                    setDraftState({
                      ...draftState,
                      companyName: queryState.data?.companyName || '',
                      locationName: queryState.data?.locationName || '',
                    });
                  }
                }}
    />
            <MutationEffect
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                mutationState={mutationState}
                effects={{
                    isError: () => {
                        setAlert('Failed to submit ticket! Please reach out to help@moutfitters.com', 'error');
                        mutationState.reset();
                    },
                    isSuccess: () => {
                        setAlert('Ticket submitted successfully!', 'success');
                        mutationState.reset();
                        navigate(AppRoutes.Tickets);
                    },
                }}
            />
        </>
    );
};
